import React from "react";
import stylesBtn from "./Button.module.scss";

/**
 *
 * @param {svg} = image format svg
 * @param {text} = string button text
 * @param {styles} = type = string = different style in Button.module.scss
 * @returns
 */
const Button = ({ svg, text, styles,type,onPress,id,disabled}) => {
  return (
    <>
      <button onClick={onPress} disabled={disabled} type={type}   className={`${stylesBtn[styles]} ${disabled ? stylesBtn.disabled : ""}`} id={id}>
        {text}
        {svg}
      </button>
    </>
  );
};

export default Button;
